import { startLoading, stopLoading } from '../slices/loadingSlice';

export const loadingMiddleware = store => next => action => {
  // Check if the action is an async thunk action
  if (action.type.endsWith('/pending')) {
    store.dispatch(startLoading());
  }
  // Check if the action has completed (either fulfilled or rejected)
  else if (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')) {
    store.dispatch(stopLoading());
  }

  return next(action);
}; 